import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationExtras,
  Params,
} from '@angular/router';

import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';

import { UsersService } from '../../services/users.service';

import { Helper } from '../../helper';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  API = this.helper.getApi();
  token = '';
  notification = { message: '', type: '' };
  clinics: string;
  superClinicId: string;
  service: string;
  type: string;
  singleClinic: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public usersService: UsersService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((query) => {
      this.token = query.token || '';
    });

    this.route.queryParams.subscribe((params: Params) => {
      this.clinics = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
    });
  }

  sendResetPassword() {
    const password1 = $('#password1').val();
    const password2 = $('#password2').val();

    if (password1 === password2) {
      const data = {
        password: password1,
        token: this.token,
        flow_url: window.location.search,
      };

      this.usersService
        .resetPassword(data)
        .subscribe(this.handleSuccess.bind(this));
    }
  }

  handleSuccess(resetResponse) {
    if (resetResponse.status === HttpStatus.OK) {
      this.notification = {
        message: 'Kodeord opdateret!',
        type: 'success',
      };

      const params = {
        type: this.type,
        service: this.service,
        singleClinic: this.singleClinic,
      };

      // if superclinic and superclinic + service flow, send params to next page
      if (this.superClinicId) {
        params['superClinicId'] = this.superClinicId;
      }

      // if singleclinic flow, send clinics params to next page
      if (this.singleClinic === 'true') {
        params['clinics'] = this.clinics;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      setTimeout(() => {
        this.router.navigate(['/login'], navigationExtras);
      }, 1500);
    } else {
      this.notification = {
        message: 'Ugyldig adgangskode!',
        type: 'error',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reset-password/reset-password.component.ts